'use strict';

module.exports = require('./Autowhatever').default;


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-autowhatever/dist/index.js
// module id = avIb
// module chunks = 0